import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAdvertiserAuthStore = create(
  persist(
    (set) => ({
      token: null,
      advertiser: null,
      setSession: (token, advertiser) => set({ token, advertiser }),
      clearSession: () => set({ token: null, advertiser: null }),
    }),
    { name: 'advertiser-auth' }
  )
);